import { render, staticRenderFns } from "./AppVersao.vue?vue&type=template&id=70cb9d77&"
import script from "./AppVersao.vue?vue&type=script&lang=js&"
export * from "./AppVersao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports